import {
	CodeOutlined,
	ExtensionOutlined,
	FormatColorFill,
	LocationOnOutlined,
	LockOutlined,
	PeopleAltOutlined,
	SmartToyOutlined,
} from "@mui/icons-material";
import { Grid } from "@mui/material";
import SettingsCard from "routes/settings/SettingsCard";
import SettingsPageTitle from "ui-library/SettingsPageTitle";

import Breadcrumbs from "../Breadcrumbs";
import useController from "./useController";
import { HasFeature } from "ui-library/HasFeature";

const Index = () => {
	useController();

	return (
		<>
			<Breadcrumbs />
			<SettingsPageTitle>Account Settings</SettingsPageTitle>

			<Grid
				columnSpacing={{ md: 3, sm: 2, xs: 1 }}
				columns={3}
				container
				rowSpacing={1}
			>
				<SettingsCard
					content="Invite members of your team to the samdesk platform"
					destination="members"
					heading="Members"
					icon={<PeopleAltOutlined />}
				/>
				<SettingsCard
					content="Upload and manage assets you'd like to monitor in samdesk"
					destination="assets"
					heading="Proximity Assets"
					icon={<LocationOnOutlined />}
				/>
				<SettingsCard
					content="Generate an API key and connect with samdesk"
					destination="api"
					heading="API"
					icon={<CodeOutlined />}
				/>
				<SettingsCard
					content="Connect your samdesk account with other services"
					destination="integrations"
					heading="Integrations"
					icon={<ExtensionOutlined />}
				/>
				<SettingsCard
					content="Control admin settings for your samdesk account"
					destination="security"
					heading="Security"
					icon={<LockOutlined />}
				/>
				<HasFeature flag="custom_logo">
					<SettingsCard
						content="Customize how your staff and assets view your communications."
						destination="personalization"
						heading="Personalization"
						icon={<FormatColorFill />}
					/>
				</HasFeature>
				<HasFeature flag="allow_impact_agent">
					<SettingsCard
						content="Set up Impact Agents to get detailed incident assessments"
						destination="impact_agents"
						heading="Impact Agents"
						icon={<SmartToyOutlined />}
					/>
				</HasFeature>
			</Grid>
		</>
	);
};

export default Index;
